import React from "react";
import Nav from "../../components/nav";
import HelpTop from "../../components/help-top";
import Footer from "../../components/footer";
import {Helmet} from "react-helmet";

const Support = ()=>{
    return(
        <div className='support-page'>
            <Helmet>
                <title>راهنمای بل میت</title>
                <meta name="description" content="در این بخش می توانید راهنماهای بل میت را ببینید." />
            </Helmet>
            <Nav />
            <div className='support-wrap'>
                <div className='item-page'>
                    <div className='page-header'>
                        <h1>صفحه ی راهنما</h1>
                    </div>
                    <div className='help-wrap'>
                        <p>در این صفحه به راهنمای متنی، راهنمای ویدیویی، آموزش های عمومی و سؤالات متداول دسترسی داشته باشید. </p>
                    </div>
                    <div className='help-items'>
                        <div className='row'>
                            <div className='col-sm-4'>
                                <HelpTop />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Support